import { Component } from '@angular/core';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';

@Component({
  selector: 'app-simple-footer',
  templateUrl: './simple-footer.component.html',
  styleUrls: ['./simple-footer.component.css']
})
export class SimpleFooterComponent {
  logoUrl:string='';
  constructor(private tenantConfigService: TenantConfigService){
    this.logoUrl = this.tenantConfigService.tenant.coloredLogoUrl;
  }
}
